import api from "./api";

const url = "privacy-portal";

const sendReportIncidentEmail = (params) =>
  api.post(`${url}/send-report-incident-email`, params);

export default {
  sendReportIncidentEmail,
};
